import React, { useMemo, useState } from 'react';
import { Alert } from 'tea-component';
import { LanguageType } from '@op/types/common';
import './index.scss';
import useIntls from '@opm/hooks/useIntls';
import { TipsMapType } from '@op/components/BubbleCommon';

export default function CommonBodyTips({
  hasMargin = false,
  horseRaceLampTips,
}: {
  hasMargin?: boolean;
  horseRaceLampTips?: TipsMapType | Array<TipsMapType>;
}) {
  const [closeTips, setCloseTips] = useState(false);
  const { isEn } = useIntls();
  const key: LanguageType = isEn ? 'en' : 'zh';

  const specialAlert = useMemo(() => {
    const list: { show: boolean; tips?: TipsMapType }[] = [];

    if (horseRaceLampTips) {
      if (Array.isArray(horseRaceLampTips)) {
        horseRaceLampTips.forEach((item) => {
          list.push({ show: true, tips: item });
        });
      } else {
        list.push({ show: true, tips: horseRaceLampTips });
      }
    }

    return list
      .map((item) => {
        if (item.show) return item.tips;
      })
      .filter(Boolean);
  }, [horseRaceLampTips]);

  return (
    <Alert
      className={`dbom-timezone-tips-wrapper ${hasMargin ? 'dbom-has-margin' : ''}`}
      visible={!closeTips && specialAlert.length > 0}
      hideIcon
      onClose={() => setCloseTips(true)}
    >
      <ul style={{ listStyle: 'disc', paddingLeft: '20px' }}>
        {specialAlert.length > 0 &&
          specialAlert.map((item: any, index) => {
            return (
              <li key={index}>
                <span>{item?.[key]}</span>
              </li>
            );
          })}
      </ul>
    </Alert>
  );
}
